import React from "react";
import { Modal } from "react-bootstrap";
import * as CryptoJS from "crypto-js";
import { Redirect, withRouter  } from "react-router-dom";
import * as SignInActions from "src/store/actions/SignInActions/SignInAction";
// import SignInReducer from "src/store/reducer/SignInReducer/SignInReducer";
import { calcMD5 } from "src/md5Forgot";
import Api from "src/network";
import "./EmailverficationModal.css";
import { CircularProgress } from "@material-ui/core";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import API from "../../../../network";
import { clearEmailAction } from "src/store/actions/emailTemplatesActions/emailTempActions";

class EmailVerificationModal extends React.Component {
  state = {
    code: ["", "", "", "", "", ""],
    isAuthenticated: false,
    errorMessage: "",
    message: "",
    isLoading: false,
  };

  handlePaste = (e) => {
    e.preventDefault();
    const pastedOtp = e.clipboardData.getData("text").trim();

    if (!/^\d{6}$/.test(pastedOtp)) return;

    this.setState({ code: pastedOtp.split(""), errorMessage: "" }, () => {
      this[`digit5`]?.focus();
    });
  };

  updateCode = (e, index) => {
    const { value } = e.target;
    const digitValue = value.length > 1 ? value.slice(-1) : value;

    if (digitValue.match(/^\d*$/)) {
      // Handle regular digit input
      const updatedCode = [...this.state.code];
      updatedCode[index] = digitValue;
      this.setState({ code: updatedCode, errorMessage: "" }, () => {
        if (index < 5 && digitValue !== "") {
          this[`digit${index + 1}`]?.focus();
        }
      });
    }
  };

  handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const updatedCode = [...this.state.code];

      // If current box has value → just clear it (DON’T move focus)
      if (updatedCode[index]) {
        updatedCode[index] = "";
        this.setState({ code: updatedCode, errorMessage: "" });
      } else if (index > 0) {
        // If already empty → move to previous and clear that
        this[`digit${index - 1}`]?.focus();

        updatedCode[index - 1] = "";
        this.setState({ code: updatedCode, errorMessage: "" });
      }
    }
  };

  codeSubmitHandler = async (e) => {
    e.preventDefault();
    // const tenantId = this.props.tentId;
    // const tenantName = this.props.tenantName;
    let formData = new FormData();
    let encodedEmail = CryptoJS.AES.encrypt(
      this.props.email,
      "skopic",
    ).toString();
    let encodedPassword = calcMD5(this.props.password);
    let dispatch = this.props.dispatch;

    formData.append("j_username", encodedEmail);

    try {
      this.setState({ isLoading: true, errorMessage: "", message: "" });
      const response = await Api.createSixdigitcodeUser(
        formData,
        this.state.code.join(""),
      );
      if (
        response?.data?.status === "Registered" ||
        response?.data?.status === "SkopicUser"
      ) {
        const emailAction = this.props.emailAction;

        if (emailAction?.action === "otp") {
          const signupCommunity = JSON.parse(
            localStorage.getItem("signupCommunity") || "{}",
          );

          const tenantId = response?.data?.tenantId || signupCommunity?.tenantId;
          const tenantName = response?.data?.tenantName || signupCommunity?.tenantName;

          Cookies.set("signInStatus", true);

          try {
            await API.changeCommunity(tenantName, tenantId);

            localStorage.removeItem("signupCommunity");

            // Set Redux value before navigating
            this.props.dispatch(SignInActions.updateIsNewUser(true));

            // Clear email action after successful OTP verification
            this.props.dispatch(clearEmailAction());

            // Navigate without full page reload
            this.props.history.push("/Home");
          } catch (error) {
            console.error("Failed to change community:", error);
            Cookies.remove("signInStatus");
            alert(
              error?.response?.data?.message ||
                error?.message ||
                "Failed to load community",
            );
          }
        } else {
          let formData = new FormData();
          formData.append("j_username", encodedEmail);
          formData.append("j_password", encodedPassword);
          formData.append("si_remember", "_spring_security_remember_me=true");
          formData.append("isNewUser", true);
          dispatch(SignInActions.signinUser(formData));
        }
        // NOW reset AFTER success
        // setTimeout(() => {
        //   this.props.signupContext?.resetSignupState();
        // }, 500);
      } else {
        this.setState({
          errorMessage: "The code you entered is incorrect.",
          message: "", // Clear the resend message
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  ResendCode = async () => {
    this.setState({
      message: "",
      errorMessage: "",
      code: ["", "", "", "", "", ""],
    });

    let formData = new FormData();
    var encodedemail = CryptoJS.AES.encrypt(
      this.props.email,
      "skopic",
    ).toString();
    formData.append("j_username", encodedemail);
    let currentComponent = this;

    try {
      const response = await Api.resendVerificationCode(formData);
      if (response.data?.status === "success") {
        this.setState({
          message:
            "The code has been sent to your Email. The code expires in 24hrs",
          errorMessage: "", //clear error message
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  closeHandler = () => {
    console.log("Closing modal");
    this.setState({
      message: null,
      code: ["", "", "", "", "", ""],
      errorMessage: null,
    });
    // this.props.onHide();
  };

  closeModal = () => {
    this.props.onHide();
  };

  render() {
    const { code } = this.state;
    const isEnabled = code.join("").length === 6 && code.every((digit) => digit.trim() !== "");

    if (this.state.isAuthenticated) {
      return <Redirect to="/Home" />;
    }

    return (
      <Modal
        {...this.props}
        onHide={this.closeHandler}
        backdrop="static" // responsible for preventing otp eraze
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="emailModal"
      >
        <div className="email-verification-container">
          <Modal.Header style={{ position: "relative" }}>
            <Modal.Title
              id="contained-modal-title-vcenter"
              style={{ color: "#373334", fontSize: "20px", fontWeight: 800 }}
            >
              Email Verification
            </Modal.Title>
            <button
              type="button"
              onClick={this.closeModal}
              className="close-button"
              aria-label="Close"
            >
              &times;
            </button>
          </Modal.Header>
          <Modal.Body style={{ paddingTop: 0 }}>
            <p style={{ textAlign: "center" }} className="text">
              Please enter the 6-digit code sent to {this.props.email}.
            </p>
            <form onSubmit={this.codeSubmitHandler}>
              <div className="btnWrapper">
                <div className="EnterCode" style={{ textAlign: "center" }}>
                  {code.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      maxLength="1"
                      name={`digit${index}`}
                      value={digit}
                      onChange={(e) => this.updateCode(e, index)}
                      onKeyDown={(e) => this.handleKeyDown(e, index)}
                      onFocus={(e) => e.target.select()}
                      ref={(input) => (this[`digit${index}`] = input)} // create refs for each input
                      autoComplete={index === 0 ? "one-time-code" : "off"}
                      style={{
                        width: "28px",
                        margin: "8px 8px 4px 8px",
                      }}
                      // placeholder="0"
                      onPaste={index === 0 ? this.handlePaste : undefined}
                    />
                  ))}
                </div>
                <p className="errorMessage" style={{ textAlign: "center" }}>
                  {this.state.errorMessage}
                </p>
                <button
                  className="ResendCode"
                  style={{ textAlign: "center" }}
                  type="button"
                  onClick={this.ResendCode}
                >
                  Resend Code
                </button>
                <button
                  type="submit"
                  style={{
                    background: isEnabled
                      ? "linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%)"
                      : "#FFFFFF",
                    color: isEnabled ? "#FFFFFF" : "#7A7A7A",
                  }}
                  disabled={!isEnabled}
                  className="FinishSignUp"
                >
                  {this.state.isLoading ? (
                    <CircularProgress
                      style={{ width: "20px", height: "20px" }}
                    />
                  ) : (
                    "Finish Sign Up"
                  )}
                </button>
                {this.state.message && (
                  <p className="ResendMessage" style={{ textAlign: "center" }}>
                    {this.state.message}
                  </p>
                )}
              </div>
            </form>
          </Modal.Body>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  emailAction: state.emailActionReducer,
});

export default withRouter(connect(mapStateToProps)(EmailVerificationModal));
